/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedContactDealerButton_item$ref = any;
type PdpSharedContactSupportButton_item$ref = any;
type PdpSharedMakeOfferButton_item$ref = any;
type PdpSharedRequestHold_item$ref = any;
export type PdpRespSidebarContact_item$ref = any;
export type PdpRespSidebarContact_item = {
    readonly isCustomizable: boolean | null;
    readonly " $fragmentRefs": PdpSharedRequestHold_item$ref & PdpSharedContactDealerButton_item$ref & PdpSharedMakeOfferButton_item$ref & PdpSharedContactSupportButton_item$ref;
    readonly " $refType": PdpRespSidebarContact_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSidebarContact_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isCustomizable",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedRequestHold_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedContactDealerButton_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedMakeOfferButton_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedContactSupportButton_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c6398452781e034901c582a7725f2e9b';
export default node;
